import { Route, Switch } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

import LandlordSetting from "../components/Landlord/LandlordSetting";
import MerchantSetting from "../components/Merchant/MerchantSetting";
import MerchantTable from "../components/Merchant/Merchant";
import LandlordTable from "../components/Landlord/Landlord";
import UserDetail from "../components/UserDetailComponent";
import TermCondition from "../components/PolicyManagement/TermCondition";
import PrivacyPolicy from "../components/PolicyManagement/PrivacyPolicy";
import ContactUs from "../components/ContactUs/ContactUs";
import MemberMobileUser from "../components/MemberMobileUser/MemberMobileUser";
import WebAdminUser from "../components/WebAdminUser/WebAdminUser";
import ChargerBrand from "../components/ChargerBrand/ChargerBrand";
import ChargerBrandSetting from "../components/ChargerBrand/ChargerBrandSetting";
import Price from "../components/Price/Price";
import PriceSetting from "../components/Price/PriceSetting";
import Charger from "../components/Charger/Charger";
import ChargerSetting from "../components/Charger/ChargerSetting";
import Booking from "../components/Booking/Booking";
import Payment from "../components/Payment/Payment";
import Promotion from "../components/Promotion/Promotion";
import PromotionSetting from "../components/Promotion/PromotionSetting";
import PointSetupComponent from "../components/PointSetupComponent";
import UserPromotion from "../components/UserPromotion/UserPromotion";
import BookingReport from "../components/BookingReport/BookingReport";
import GuideSetting from "../components/Guide/GuideSetting";
import GuideTable from "../components/Guide/GuideTable";
import PopupSetting from "../components/Popup/PopupSetting";
import PopupTable from "../components/Popup/PopupTable";
import GuideManage from "../components/Guide/GuideManage";
import NotFoundPage from "../components/NotFoundPage";
import UserPromotionReport from "../components/UserPromotionReport/UserPromotionReport";
import PartySetting from "../components/Party/PartySetting";
import Party from "../components/Party/Party";

const PrivateRouteList = () => {
  return (
    <Switch>
      <PrivateRoute path="/point-setup" component={PointSetupComponent} />

      <PrivateRoute path="/user-promotion-report" component={UserPromotionReport} />

      <PrivateRoute path="/user-promotion" component={UserPromotion} />

      <PrivateRoute path="/promotion/:type/:id" component={PromotionSetting} />
      <PrivateRoute path="/promotion/:type" component={Promotion} />

      <PrivateRoute path="/charging-payment" component={Payment} />

      <PrivateRoute path="/booking-report" component={BookingReport} />
      <PrivateRoute path="/booking-management" component={Booking} />

      <PrivateRoute path="/charger/:id" component={ChargerSetting} />
      <PrivateRoute path="/charger" component={Charger} />

      <PrivateRoute path="/price/:id" component={PriceSetting} />
      <PrivateRoute path="/price" component={Price} />

      <PrivateRoute path="/charger-brand/:id" component={ChargerBrandSetting} />
      <PrivateRoute path="/charger-brand" component={ChargerBrand} />

      <PrivateRoute path="/landlord/:id" component={LandlordSetting} />
      <PrivateRoute path="/landlord" component={LandlordTable} />

      <PrivateRoute path="/party/:id" component={PartySetting} />
      <PrivateRoute path="/party" component={Party} />

      <PrivateRoute path="/merchant/:id" component={MerchantSetting} />
      <PrivateRoute path="/merchant" component={MerchantTable} />

      <PrivateRoute path="/web-admin" component={WebAdminUser} />
      <PrivateRoute path="/member-mobile-user" component={MemberMobileUser} />

      <PrivateRoute path="/contact-us" component={ContactUs} />

      <PrivateRoute path="/guide/:id" component={GuideSetting} />
      <PrivateRoute path="/guide" component={GuideTable} />
      <PrivateRoute path="/guide-manage" component={GuideManage} />
      <PrivateRoute path="/popup/:id" component={PopupSetting} />
      <PrivateRoute path="/popup" component={PopupTable} />
      <PrivateRoute path="/term-condition" component={TermCondition} />
      <PrivateRoute path="/privacy-policy" component={PrivacyPolicy} />

      <PrivateRoute path="/user-detail" component={UserDetail} />

      <Route component={NotFoundPage} />
    </Switch>
  );
};

export default PrivateRouteList;
